import { fabric } from 'fabric';
import ToolOption from '../common/ToolOption';
import { CanvasEventType, GraphName, GraphType } from '../constants/Constants';
import UndoManager from '../manager/UndoManager';
import log from 'loglevel';
import Graphic from './Graphic';

/**
 * 方块
 *
 * @export
 * @class CanvasSquare
 * @extends {Graphic}
 * @author zhenliang.sun
 */
export default class CanvasSquare extends Graphic {
  constructor(app) {
    super(app);

    // var r = new fabric.Rect();
    // r.setFill
  }

  get option() {
    return this._option;
  }

  set option(val) {
    super.option = val;

    if (!val) {
      this._option = this.defaultOption;
    }

    Object.assign(this._option, val);
  }

  get defaultOption() {
    return new ToolOption();
  }

  addEvents() {
    super.addEvents();
    let rect, isMousedown, ox, oy;

    this.root.on(CanvasEventType.MouseDown, o => {
      isMousedown = true;
      let sp = this.root.getPointer(o.e);
      ox = sp.x;
      oy = sp.y;
      sp = this.root.getPointer(o.e);
      rect = new fabric[GraphName.SQUARE]({
        left: ox,
        top: oy,
        originX: 'left',
        originY: 'top',
        width: sp.x - ox,
        height: sp.y - oy,
        angle: 0,
        fill: this.option.fill,
        stroke: this.option.stroke,
        strokeWidth: this.option.strokeWidth
        // fill: "",
        // stroke: Math.random() * 0xFFFFFF,
        // strokeWidth: Math.floor(Math.random() * 10) + 1
      });
      rect.selectable = false;
      log.info(o, sp, rect);
      this.root.add(rect);
    });
    this.root.on(CanvasEventType.MouseMove, o => {
      if (!isMousedown) {
        return;
      }

      let pointer = this.root.getPointer(o.e);
      if (ox > pointer.x) {
        rect.set({
          left: Math.abs(pointer.x)
        });
      }
      if (oy > pointer.y) {
        rect.set({
          top: Math.abs(pointer.y)
        });
      }
      let w = Math.abs(ox - pointer.x);
      let h = Math.abs(oy - pointer.y);
      rect.set({
        width: w,
        height: h
      });
      this.stage.renderNow();
    });
    this.root.on(CanvasEventType.MouseUp, e => {
      isMousedown = false;
      log.info(e, rect.toJSON());
      rect.setCoords();
      // this.root.setActiveObject(rect);

      let data = this.factory.createAddData(rect);
      // MsgSender.add(data)
      this.app.sender.add(data);
      let allData = this.root.toDatalessJSON();
      UndoManager.getInstance().save(allData);
    });
  }

  removeEvents() {
    super.removeEvents();
    this.root.off(CanvasEventType.MouseDown);
    this.root.off(CanvasEventType.MouseMove);
    this.root.off(CanvasEventType.MouseUp);
  }

  static toAddData(target) {
    let obj = Graphic.toAddData(target);
    obj.gtype = GraphType.SQUARE;
    obj.fill = '';
    return obj;
    // {"type":"rect","gtype":3,"uuid":"d24a4","uniqueID":1526452043878,"left":"136.5","top":"348.6","stroke":"#fff000","strokeWidth":6,"width":"125.5","height":"107.6"}
  }
}
